import { Component } from '@angular/core';
import { MatCardModule } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-pagenotfound',
  standalone: true,
  imports: [
    MatCardModule,
    MatIcon,
    MatButton
  ],
  templateUrl: './pagenotfound.component.html',
  styleUrl: './pagenotfound.component.css'
})
export class PagenotfoundComponent {
  constructor(private router: Router) {
  }

  voltar(): void {
    this.router.navigate(['ava-unesp']);
  }
}
